import React, { Component } from "react";
import { COMPANY, LABEL_UNIVERSITY, ROUTES } from "const";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router-dom";
import { BandiEvaluationGrid } from "./bandoEvaluation/BandiEvaluationGrid";

class BandoEvaluationInfoBrowser extends Component {

    _class1Ref = null;


    state = {

        loading: true,
        currentAA: '2025',
        company: '',
        currentEdition: 1,
    }

    componentDidMount() {

        this.setState({ loading: true });
        const { company, currentEdition = 1 } = this.props.match.params;

        // if company is not empty and is not in LABEL_UNIVERSITY, then go to 404 page
        if (company && !LABEL_UNIVERSITY[company]) {
            this.props.history.push(ROUTES.PAGE_404);
        }

        this.setState({ company: company, currentEdition: currentEdition, loading: false });
    }

    renderReggio() {

        // TODO SAVERIO: sistemare sta cosa, la data va letta dal DB
        let deadline = 'Lunedi 23 Febbraio 2026 alle ore 15:00';        
        if (this.state.currentEdition === '2') {
            deadline = 'Lunedì 2 Marzo 2026 alle ore 15:00';
        }else if (this.state.currentEdition === '3') {
            deadline = 'Lunedì 9 Marzo 2026 alle ore 15:00';
        }else if (this.state.currentEdition === '4') {
            deadline = 'Lunedì 16 Marzo 2026 alle ore 15:00';
        } else if (this.state.currentEdition === '5') {
            deadline = 'Lunedì 23 Marzo 2026 alle ore 15:00';
        }

        return (
            <div>
                <p>Per l'a.a. 2025/2026 il Ministero con il Decreto Ministeriale n. 137 del 26-01-2026 e il n. 138 del 27-01-2026 ha autorizzato
                    l'Università per Stranieri "Dante Alighieri" di Reggio Calabria, all'attivazione dei Percorsi universitari di formazione iniziale dei docenti
                    delle scuole secondarie di primo e secondo grado.</p>
                <hr />
                <h3>Graduatorie</h3>
                <p><b>Graduatorie dei Corsi 60 CFU all. 1 e ai Corsi 30 CFU all. 2</b> </p>
                <p>Consulta le graduatorie 60 e 30 CFU. Si ricorda che gli AMMESSI dovranno immatricolarsi entro e
                    non oltre {deadline} pena esclusione definitiva dalla graduatoria.</p>
                <BandiEvaluationGrid bandoEdition={this.state.currentEdition} aa={this.state.currentAA} company={this.state.company} />
                <hr />
                <p><b>ATTENZIONE:</b></p>
                <p> Tutte le informazioni relative ai suddetti corsi saranno rese disponibili esclusivamente attraverso il presente sito web e tramite la propria area riservata.</p>
                <p>Si precisa che non è previsto alcun servizio di consulenza individuale, pertanto non saranno fornite risposte personalizzate tramite altri canali.</p>

            </div>
        );
    }

    renderUnitelma() {

        // TODO SAVERIO: sistemare sta cosa, la data va letta dal DB
        let deadline = 'Lunedi 9 Febbraio 2026';
        if (this.state.currentEdition === '2') {
            deadline = 'Giovedi 12 Febbraio 2026 alle ore 15:00';
        } else if (this.state.currentEdition === '3') {
            deadline = 'Giovedi 19 Febbraio 2026 alle ore 15:00';
        } else if (this.state.currentEdition === '4') {
            deadline = 'Giovedi 26 Febbraio 2026 alle ore 16:00';
        } else if (this.state.currentEdition === '5') {
            deadline = 'Giovedi 5 Marzo 2026 alle ore 16:00';
        }

        return (
            <div>
                <p>Per l'a.a. 2025/2026 il Ministero con il Decreto Ministeriale n. 137 del 26-01-2026 e il n. 138 del 27-01-2026 ha autorizzato
                    l'Università degli Studi di Roma Unitelma Sapienza, all'attivazione dei Percorsi universitari di formazione iniziale dei docenti
                    delle scuole secondarie di primo e secondo grado.</p>
                <hr />
                <h3>Graduatorie</h3>
                <p><b>Graduatorie dei Corsi 60 CFU all. 1 e ai Corsi 30 CFU all. 2</b> </p>
                <p>Consulta le graduatorie 60 e 30 CFU. Si ricorda che gli AMMESSI dovranno immatricolarsi entro e
                    non oltre {deadline} pena esclusione definitiva dalla graduatoria.</p>
                <BandiEvaluationGrid bandoEdition={this.state.currentEdition} aa={this.state.currentAA} company={this.state.company} />
                <hr />
                <p><b>ATTENZIONE:</b></p>
                <p> Tutte le informazioni relative ai suddetti corsi saranno rese disponibili esclusivamente attraverso il presente sito web e tramite la propria area riservata.</p>
                <p>Si precisa che non è previsto alcun servizio di consulenza individuale, pertanto non saranno fornite risposte personalizzate tramite altri canali.</p>

            </div>
        );
    }

    renderUnicamillus() {

        // TODO SAVERIO: sistemare sta cosa, la data va letta dal DB
        let deadline = 'Venerdì 6 Febbraio 2026';
        if (this.state.currentEdition === '2') {
            deadline = 'Mercoledì 11 Febbraio 2026 alle ore 15:00';
        }else if (this.state.currentEdition === '3') {
            deadline = 'Martedì 17 Febbraio 2026 alle ore 16:00';
        } else if (this.state.currentEdition === '4') {
            deadline = 'Martedì 24 Febbraio 2026 alle ore 16:00';
        } else if (this.state.currentEdition === '5') {
            deadline = 'Martedì 3 Marzo 2026 alle ore 16:00';
        }


        return (
            <div>
                <p>Per l'a.a. 2025/2026 il Ministero con il Decreto Ministeriale n. 137 del 26-01-2026 e il n. 138 del 27-01-2026 ha autorizzato
                    l'Università Unicamillus - Saint Camillus International University of Health Sciences all'attivazione dei Percorsi universitari
                    di formazione iniziale dei docenti delle scuole secondarie di primo e secondo grado.  </p>
                <hr />
                <h3>Graduatorie</h3>
                <p><b>Graduatorie dei Corsi 60 CFU all. 1 e ai Corsi 30 CFU all. 2</b> </p>
                <p>Consulta le graduatorie 60 e 30 CFU. Si ricorda che gli AMMESSI dovranno immatricolarsi entro e
                    non oltre {deadline} pena esclusione definitiva dalla graduatoria.</p>
                <BandiEvaluationGrid bandoEdition={this.state.currentEdition} aa={this.state.currentAA} company={this.state.company} />
                <hr />
                <p><b>ATTENZIONE:</b></p>
                <p> Tutte le informazioni relative ai suddetti corsi saranno rese disponibili esclusivamente attraverso il presente sito web e tramite la propria area riservata.</p>
                <p>Si precisa che non è previsto alcun servizio di consulenza individuale, pertanto non saranno fornite risposte personalizzate tramite altri canali.</p>

            </div>
        );
    }

    render() {

        let content = '';
        const title = "Percorsi Abilitanti 60 e 30 CFU  D.P.C.M. 4 AGOSTO 2023";
        if (this.state.loading) return false;

        const { company } = this.props.match.params;
        if (company === COMPANY.UNITELMA) {
            content = this.renderUnitelma();
        } else if (company === COMPANY.REGGIO) {
            content = this.renderReggio();
        } else if (company === COMPANY.UNICAMILLUS) {
            content = this.renderUnicamillus();
        }

        return (
            <>
                <section className="my-4">
                    <Helmet>
                        <title>{title}</title>
                        <meta property="og:title" content={title} />
                    </Helmet>
                    <div>
                        <h1>{title} - A.A. 2025/2026</h1>
                    </div>
                    {content}
                    <hr />
                </section>

            </>
        );
    }
}


export default withRouter(BandoEvaluationInfoBrowser);

